<router-outlet></router-outlet>
@if (isNewAppVersionAvailable) {
  <app-update-worker (update)="refreshApp()"/>
}
